import {
	AccordionProps,
	Accordion as MuiAccordion,
	AccordionSummary as MuiAccordionSummary,
	AccordionDetails as MuiAccordionDetails,
	AccordionSummaryProps,
	accordionSummaryClasses,
	ToggleButtonGroup,
	toggleButtonGroupClasses,
	Popper,
} from "@mui/material";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import { styled } from "@mui/material/styles";
import {
	backgroundBrandSecondary,
} from "../../../../core/theme";

export const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    "&:not(:last-child)": {
        borderBottom: 0,
    },
    "&::before": {
        display: "none",
    },
}));

export const AccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: backgroundBrandSecondary,
    [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
        {
            transform: "rotate(90deg)",
        },
    [`& .${accordionSummaryClasses.content}`]: {
        marginLeft: theme.spacing(1),
    },
}));

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    [`& .${toggleButtonGroupClasses.grouped}`]: {
        margin: theme.spacing(0.5),
        border: 0,
        borderRadius: theme.shape.borderRadius,
        textTransform: "none",

        [`&.${toggleButtonGroupClasses.disabled}`]: {
            border: 0,
        },
    },
    backgroundColor: "#052B5014",
    height: "32px",
    [`& .Mui-selected`]: {
        backgroundColor: "white !important",
    },
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export const StyledPopper = styled(Popper)(() => ({
    border: "1px solid #e1e4e8",
    boxShadow: `0 8px 24px ${"rgba(149, 157, 165, 0.2)"}`,
    backgroundColor: "#fff",
    width: 300,
    fontSize: 13,
}));
